export const GET_MULTI_TAXES = 'providers/settings/MultiTaxes/GET_MULTI_TAXES';
export const UPDATE_DEFAULT_MULTI_TAXES = 'providers/settings/MultiTaxes/UPDATE_DEFAULT_MULTI_TAXES';
